import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { IMAGE_BASE } from '../../services/api';
import { X, Minus, Plus, Trash2, ShoppingBag, ShoppingCart } from 'lucide-react';

export default function CartSidebar() {
    const { cart, sidebarOpen, setSidebarOpen, updateItem, removeItem } = useCart();

    const formatPrice = (p) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(p);

    const getImageUrl = (url) => url?.startsWith('http') ? url : IMAGE_BASE + url;

    return (
        <>
            <div className={`cart-sidebar-backdrop ${sidebarOpen ? 'open' : ''}`} onClick={() => setSidebarOpen(false)} />
            <div className={`cart-sidebar ${sidebarOpen ? 'open' : ''}`}>
                <div className="cart-sidebar-header">
                    <h3><ShoppingBag size={20} /> Sepetim ({cart.itemCount})</h3>
                    <button onClick={() => setSidebarOpen(false)} className="cart-sidebar-close"><X size={22} /></button>
                </div>

                {cart.items.length === 0 ? (
                    <div className="cart-sidebar-empty">
                        <ShoppingBag size={48} strokeWidth={1} />
                        <p>Sepetiniz boş</p>
                        <Link to="/urunler" className="btn btn-primary" onClick={() => setSidebarOpen(false)}>Ürünleri Keşfet</Link>
                    </div>
                ) : (
                    <>
                        <div className="cart-sidebar-items">
                            {cart.items.map(item => (
                                <div key={item.id} className="cart-sidebar-item">
                                    <div className="cart-item-img">
                                        {item.image ? (
                                            <img src={getImageUrl(item.image)} alt={item.productName} />
                                        ) : (
                                            <div className="cart-item-placeholder"><ShoppingBag size={20} /></div>
                                        )}
                                    </div>
                                    <div className="cart-item-info">
                                        <Link to={`/urun/${item.productSlug}`} onClick={() => setSidebarOpen(false)} className="cart-item-name">
                                            {item.productName}
                                        </Link>
                                        {item.variantInfo && <span className="cart-item-variant">{item.variantInfo}</span>}
                                        <span className="cart-item-price">{formatPrice(item.price)}</span>
                                        <div className="cart-item-qty">
                                            <button onClick={() => updateItem(item.id, item.quantity - 1)} disabled={item.quantity <= 1}>
                                                <Minus size={14} />
                                            </button>
                                            <span>{item.quantity}</span>
                                            <button onClick={() => updateItem(item.id, item.quantity + 1)} disabled={item.quantity >= item.stock}>
                                                <Plus size={14} />
                                            </button>
                                            <button className="cart-item-remove" onClick={() => removeItem(item.id)}>
                                                <Trash2 size={14} />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="cart-item-total">{formatPrice(item.lineTotal)}</div>
                                </div>
                            ))}
                        </div>
                        <div className="cart-sidebar-footer">
                            <div className="cart-sidebar-total">
                                <span>Toplam</span>
                                <strong>{formatPrice(cart.totalAmount)}</strong>
                            </div>
                            <Link to="/checkout" className="btn btn-primary cart-checkout-btn" onClick={() => setSidebarOpen(false)}>
                                Siparişi Tamamla
                            </Link>
                            <button className="btn btn-secondary cart-continue-btn" onClick={() => setSidebarOpen(false)}>
                                Alışverişe Devam Et
                            </button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
